import { render } from "./RecentActivityCard.vue?vue&type=template&id=ac728e98"
import script from "./RecentActivityCard.vue?vue&type=script&lang=js"
export * from "./RecentActivityCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__